import styled from 'styled-components'

export const IntakeField = styled.div`
  font-size: 10pt;
  color: ${props => props.theme.fontColor};
  margin: 0 20px 10px 0;
  text-align: left;

  label {
    overflow: hidden;
  }
  span {
    font-weight: 600;
  }
  p {
    font-size: 10pt !important;
  }
`
